<template>
  <section>
    <div class="left">
      <h2 v-translate>Videotéka</h2>
    </div>
    <div class="right">
      <div class="field_left">
        <checkbox-input
            id="vodallowpurchaseunprocessedvideo"
            v-model="entity.vod_allow_purchase_unprocessed_video"
            :disabled="!allowEditPurchability"
            :help-text="$gettext('Umožní zakoupit TVOD videa, která ještě nebyla zpracována k přehrání')"
        >
          <translate class="translate">Povolit nákup nepřipravených titulů</translate>
        </checkbox-input>
      </div>
    </div>
    <div class="right checkbox_group">
      <div class="package_box_wrapper">
        <div class="package_box" v-for="(provider, key) in vodProviders" :key="'vod_provider_'+key">
          <p class="field package_box_name">
            <input
                :id="'vodproviders_' + key"
                :name="'vodproviders_' + key"
                type="checkbox"
                :value="provider.id"
                v-model="selectedIds"
                :disabled="!isEditable"
            />
            <label :for="'vodproviders_' + key">{{ provider.text }}</label>
          </p>
              <div class="added_period added_period_box" v-for="vodPackage in provider.package_visibility" :key="'package_'+vodPackage.id">
                <strong>{{vodPackage.text}}</strong>
                <select-box
                    :id="'package_visibility_'+vodPackage.id"
                    :options="nullableBooleanOptions"
                    :disabled="!isEditable || !selectedIds.includes(provider.id)"
                    v-model="packageVisibility[provider.id][vodPackage.id]"
                    :help-text="getOperatorHelpText(vodPackage)"
                    @input="onPackageVisibilityChange()"
                >
                  <translate class="translate">Viditelnost</translate>
                </select-box>
                <text-input
                    v-if="vodPackage.type == 'VOD_SVOD'"
                    :key="'package_visibility_selfservice_id'+vodPackage.id"
                    :id="'package_visibility_selfservice_id'+vodPackage.id"
                    :disabled="!isEditable || !selectedIds.includes(provider.id)"
                    v-model="packageSelfServiceItemId[provider.id][vodPackage.id]"
                    @change="onPackageVisibilityChange()"

                >
                  <translate class="translate">Id služby v samoobsluze</translate>
                </text-input>
              </div>
        </div>
      </div>
    </div>
    <div v-if="!hasVodProviders" class="right" v-translate>Aktuálně nejsou dostupní žádní poskytovatelé videí videotéky</div>
  </section>
</template>

<script>
import {getCorrectBooleanValue, getTextValueFromBooleanOrNull} from "@/utils/helpers"

export default {
  name: "OperatorVodProviders",
  props: {
    entity: Object,
    idOperator: Number,
    isEditable: Boolean,
    idBusinessModel: Number,
  },
  data() {
    return {
      vodProviders: [],
      packageVisibility: {},
      packageSelfServiceItemId: {},
    }
  },
  created(VodProviderService) {
    this.vodProviderService = VodProviderService;
    this.vodProviderService.getListWithPackagesVisibility({'id_business_model': this.idBusinessModel, 'id_operator': this.idOperator})
        .then((data) => {
          this.vodProviders = data['vodProviders'];
          this.vodProviders.forEach((provider) => {
            this.$set(this.packageVisibility, provider.id, {});
            this.$set(this.packageSelfServiceItemId, provider.id, {});
            provider.package_visibility.forEach((vodPackage) => {
              this.$set(this.packageVisibility[provider.id], vodPackage.id, vodPackage.operator ? vodPackage.operator.visibility : null)
              this.$set(
                  this.packageSelfServiceItemId[provider.id],
                  vodPackage.id,
                  (vodPackage.operator && Object.prototype.hasOwnProperty.call(vodPackage.operator, 'self_service_id'))
                      ? vodPackage.operator.self_service_id
                      : ""
              )
            })

          });
        })
  },
  computed: {
    hasVodProviders(){
      return this.vodProviders.length > 0;
    },
    selectedIds: {
      get() {
        return this.entity.vod_providers;
      },
      set(value) {
        this.entity.vod_providers = value;
      }
    },
    nullableBooleanOptions() {
      var result = [
        {id: true, text: this.$gettext('Ano')},
        {id: false, text: this.$gettext('Ne')},
      ];
      result.unshift({id: null, text: this.$gettext('Neurčeno')});

      return result;
    },
    allowEditPurchability(){
      return this.isEditable || this.$_loggedUser_action_allowed('operators', 'read', 'OWN');
    }
  },
  methods: {
    onPackageVisibilityChange(){
      this.$nextTick(() => {
        let result = {};
        for(let i in this.packageVisibility){
          let packages = {};
          for(let j in this.packageVisibility[i]){
            packages[j] = {
              'visibility': getCorrectBooleanValue(this.packageVisibility[i][j]),
              'self_service_id': this.packageSelfServiceItemId[i][j]
            };
          }
          result[i] = packages;
        }
        this.entity.vod_package_settings = result;
      })
    },
    getOperatorHelpText(packageData){
      return this.$gettext('Business model') +': '+ getTextValueFromBooleanOrNull(this, packageData.business_model);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/operators/settings/VodProviders.vue